import { reject } from "../../../../../Common/TypingUtils";

import { extractPath, extractTokens } from "./PathHelper";

type Nullable<T> = undefined | null | T;

export type RecursiveRequired<T> = {
    [P in keyof T]-?: T[P] extends Array<infer U>
        ? NonNullable<Array<RecursiveRequired<U>>>
        : T[P] extends Nullable<infer U1>
          ? RecursiveRequired<U1>
          : T[P];
};

export interface ValueBind<T> {
    value: T;
    onValueChange: (nextValue: T) => void;
}

export function pathLens<TI, TR>(
    input: ValueBind<TI>,
    pathSelector: (input: RecursiveRequired<TI>) => TR
): ValueBind<TR> {
    const pathTokens = extractTokens(extractPath(pathSelector.toString()));
    return {
        value: getIn(input.value, pathTokens),
        onValueChange: (nextValue: TR) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            input.onValueChange(setIn(input.value, pathTokens, nextValue));
        },
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setIn(state: any, keys: string[], value: unknown): any {
    const obj = { ...state };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-return
    const last: any = keys.slice(0, -1).reduce((part, key) => (part[key] = part[key] ? { ...part[key] } : {}), obj);

    last[keys.slice(-1)[0] ?? reject()] = value;

    return obj;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getIn(state: any = {}, keys: Array<undefined | number | string>, defaultValue?: any): any {
    let value = state;

    for (const key of keys) {
        // @ts-ignore
        if (value[key] === null) {
            return null;
        }

        // @ts-ignore
        if (value[key] === undefined) {
            return defaultValue;
        }

        // @ts-ignore
        value = value[key];
    }

    return value;
}
